import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeDeExtra from '@angular/common/locales/extra/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { deLocale, defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';

import { Store } from '@ngrx/store';
import { CustomMissingTranslationHandler } from './missing-translation-handler';
import { createTranslateLoader } from './translator-loader-factory';
import { AuthSelectors } from '../../core/auth/selectors/auth.selectors';
import getUserLanguage = AuthSelectors.getUserLanguage;

deLocale.weekdaysShort = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
deLocale.week = { ...deLocale.week, dow: 0 };
defineLocale('de', deLocale);
defineLocale('en', enGbLocale);
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeEn, 'en-US');

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      defaultLanguage: 'de',
      useDefaultLang: true,
    }),
  ],
  exports: [TranslateModule],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: (translatService: TranslateService) => {
        if (translatService.currentLang === 'de') {
          return 'de-DE';
        } else {
          return 'en-US';
        }
      },
      deps: [TranslateService],
    },
  ],
})
export class CustomTranslatorModule {
  constructor(private translateService: TranslateService, private store: Store) {
    this.onLanguageChange();
  }

  private onLanguageChange() {
    this.store.select(getUserLanguage).subscribe((language) => {
      this.translateService.use(language || 'de');
    });
  }
}
